import * as API from 'modules/app/API'
import * as FW from 'fw/system/FW'
import * as Notifications from 'fw/globals/Notifications'
import fwAPI from 'fw/system/API'

const MONITOR_POLL_INTERVAL = 500;

export const execute = (rq, callback) => {
    API.Reporting.post('/execute', rq,
        {
            success: (sr) => {
                open(sr.data);

                if (callback)
                    callback();
            },
            error: (sr) => {
                Notifications.error(sr.error.errorMessage);
            }
        });
}

export const trigger = (rq, callback) => {
    API.Reporting.post('/trigger', rq,
        {
            success: callback,
            error: (sr) => {
                Notifications.error(sr.error.errorMessage);
            }
        },
        { block: false });
}

export const monitor = (executionKey, callbacks) => {
    API.Reporting.post('/monitor/', { executionKey },
        {
            success: (sr) => {
                // It's not running? Then we finished... otherwise, keep polling
                if (sr.data.running) {
                    callbacks.progress(sr);
                    setTimeout(monitor, MONITOR_POLL_INTERVAL, executionKey, callbacks);
                }
                else {
                    open(sr.data);
                    callbacks.finished();
                }
            },
        },
        { block: false });
}

export const schedule = (rq, callbacks) => {
    API.Reporting.post('/schedule', rq,
        {
            success: (sr) => {
                Notifications.success(sr.message);

                callbacks && callbacks.success && callbacks.success();
            },
            error: (sr) => {
                Notifications.error(sr.error.errorMessage);

                callbacks && callbacks.error && callbacks.error();
            }
        });
}

export const removeSchedule = (reportScheduleId) => {
    API.Reporting.post('/removeSchedule/', { reportScheduleId },
        {
            success: (sr) => {
                Notifications.success(sr.message);
            }
        });
}

export const cancel = (executionKey) => {
    try {
        // Cancel on the server
        API.Reporting.post('/cancel/', { executionKey });
    }
    catch (err) {
        console.warn("Error cancelling report execution.", err);
    }
}

export const open = (data) => {
    // Open file in new window
    if (data.storageToken != null) {
        // View or download?
        if (data.format === "PDF")
            window.open(FW.getSettings().fileViewUrl + data.storageToken);
        else
            (new fwAPI()).download(
                {
                    storageToken: data.storageToken,
                    fileName: data.clientFileName
                }
            )
    }
}


// WEBPACK FOOTER //
// ./src/modules/reports/ReportManager.js